<ion-app>
  <!-- <app-sidebarmenu></app-sidebarmenu> -->
  <ion-menu menuId="main-menu" side="start" contentId="main-content">
    <app-mainmenu [enableSidebarMenu]="true"></app-mainmenu>
  </ion-menu>

  <ion-menu [swipeGesture]="false" menuId="menu-history" side="end" contentId="main-content">
    <app-menueditorhistory></app-menueditorhistory>
  </ion-menu>

  <div id="main-content" class="main-content">
    <ion-router-outlet main></ion-router-outlet>
  </div>
</ion-app>


